export { default } from './Demographic';
